import { c as _c } from "react/compiler-runtime";
import { Button } from "@chatapp/ui/components/button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuGroup, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger } from "@chatapp/ui/components/dropdown-menu";
import { Skeleton } from "@chatapp/ui/components/skeleton";
import Link from "next/link";
import { useRouter } from "next/navigation";
import { signOut, useSession } from "@/lib/auth-client";
export default function UserMenu() {
  const $ = _c(17);
  const router = useRouter();
  const {
    data: session,
    isPending
  } = useSession();
  if (isPending) {
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = <Skeleton className="h-9 w-24" />;
      $[0] = t0;
    } else {
      t0 = $[0];
    }
    return t0;
  }
  if (!session) {
    let t0;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = <Link href="/login"><Button variant="outline">Sign In</Button></Link>;
      $[1] = t0;
    } else {
      t0 = $[1];
    }
    return t0;
  }
  let t0;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Button variant="outline" />;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] !== session.user.name) {
    t1 = <DropdownMenuTrigger render={t0}>{session.user.name}</DropdownMenuTrigger>;
    $[3] = session.user.name;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <DropdownMenuLabel>My Account</DropdownMenuLabel>;
    t3 = <DropdownMenuSeparator />;
    $[5] = t2;
    $[6] = t3;
  } else {
    t2 = $[5];
    t3 = $[6];
  }
  let t4;
  if ($[7] !== session.user.email) {
    t4 = <DropdownMenuItem>{session.user.email}</DropdownMenuItem>;
    $[7] = session.user.email;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== router) {
    t5 = <DropdownMenuItem variant="destructive" onClick={() => {
      signOut({
        fetchOptions: {
          onSuccess: () => {
            router.push("/");
          }
        }
      });
    }}>Sign Out</DropdownMenuItem>;
    $[9] = router;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t4 || $[12] !== t5) {
    t6 = <DropdownMenuContent className="bg-card"><DropdownMenuGroup>{t2}{t3}{t4}{t5}</DropdownMenuGroup></DropdownMenuContent>;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t1 || $[15] !== t6) {
    t7 = <DropdownMenu>{t1}{t6}</DropdownMenu>;
    $[14] = t1;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  return t7;
}